import { Chip, Grid } from "@mui/material";
import { MerchantLink } from "Components/Admin/Terminals/MerchantLink";
import { GridItem } from "Components/Shared/GridItem";
import type { TerminalInventoryListItemDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";
import { formatDate } from "Utils/DateUtils";

const RESOURCES = Resources.Admin.Terminals;

type Props = {
  terminal: TerminalInventoryListItemDto;
  /** Live form value — financing follows the hunter field, not the stored row. */
  isHunterFinanced: boolean;
};

/** Read-only facts about the piece — everything editable lives in the form below. */
export const TerminalInfoGrid = ({ terminal, isHunterFinanced }: Props) => {
  const { t } = useResource();

  return (
    <Grid container spacing={2}>
      <GridItem
        label={t(RESOURCES.Table.Financing)}
        columns={2}
        value={
          <Chip
            label={
              isHunterFinanced
                ? t(RESOURCES.Financing.Hunter)
                : t(RESOURCES.Financing.Moone)
            }
            size="small"
            variant="outlined"
          />
        }
      />
      <GridItem
        label={t(RESOURCES.Table.Tid)}
        columns={2}
        value={terminal.tid}
      />
      <GridItem
        label={t(RESOURCES.Table.Mid)}
        columns={2}
        value={terminal.comgateMid}
      />
      <GridItem
        label={t(RESOURCES.Table.Merchant)}
        columns={2}
        value={
          terminal.merchantName && (
            <MerchantLink
              name={terminal.merchantName}
              publicID={terminal.merchantPublicID}
            />
          )
        }
      />
      <GridItem
        label={t(RESOURCES.Table.Facility)}
        columns={2}
        value={terminal.facilityName}
      />
      <GridItem
        label={t(RESOURCES.Table.LastChangedAt)}
        columns={2}
        value={formatDate(terminal.lastChangedAt, true)}
      />
    </Grid>
  );
};
